import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Card,
  CircularProgress,
  Alert,
  Snackbar,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../AuthContext/AuthContext";
import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";
import { BASE_URL } from "../../Api/ApiUrls";
import DeleteFailureAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteFailureAlert';
import DeleteSuccessAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteSuccessAlert';
import DeleteConfirmAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteConfirmAlert';

const User_BankAuction = () => {
  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);
const [propertyToDelete, setPropertyToDelete] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [locationLoadingId, setLocationLoadingId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
const [showDeleteFailure, setShowDeleteFailure] = useState(false);
const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
const [requestToDelete, setRequestToDelete] = useState(null);
const [alertMessage, setAlertMessage] = useState("");

  
  // State to track current image index for each card
  const [currentImageIndices, setCurrentImageIndices] = useState({});

  const colors = {
    primary: "#1a1a1a",
    background: "#efe7dd",
    cardBg: "#ffffff",
    muted: "#666",
  };

  // Currency formatter
  const formatCurrency = (amount) => {
    if (!amount) return "₹0";
    const num = Number(amount);
    if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
    if (num >= 100000) return `₹${(num / 100000).toFixed(1)} L`;
    if (num >= 1000) return `${Math.round(num / 1000)} K`;
    return `₹${num.toLocaleString()}`;
  };

  // Get all image URLs
  const getAllImageUrls = (docArray) => {
    if (!docArray || docArray.length === 0) {
      return [];
    }
    
    return docArray.map(doc => {
      if (doc.document) {
        if (doc.document.startsWith('/')) {
          return `${BASE_URL}${doc.document}`;
        }
        return doc.document;
      }
      return null;
    }).filter(url => url !== null);
  };

  const handleCardClick = (item) => {
    if (item.lat && item.long) {
      localStorage.setItem('propertyLat', item.lat);
      localStorage.setItem('propertyLong', item.long);
    }
    // navigate(`/User_BankAuction_detail/${item.bankprop_id}`);
    navigate(`/Post_Bankcard_indetail/${item.bankprop_id}`);

  };

  // Carousel navigation functions
  const nextImage = (e, bankpropId, totalImages) => {
    e.stopPropagation();
    setCurrentImageIndices(prev => {
      const currentIndex = prev[bankpropId] || 0;
      const newIndex = (currentIndex + 1) % totalImages;
      return { ...prev, [bankpropId]: newIndex };
    });
  };

  const prevImage = (e, bankpropId, totalImages) => {
    e.stopPropagation();
    setCurrentImageIndices(prev => {
      const currentIndex = prev[bankpropId] || 0;
      const newIndex = (currentIndex - 1 + totalImages) % totalImages;
      return { ...prev, [bankpropId]: newIndex };
    });
  };

  // Handle dot click
  const handleDotClick = (e, bankpropId, index) => {
    e.stopPropagation();
    setCurrentImageIndices(prev => ({ ...prev, [bankpropId]: index }));
  };

  // FIXED: Location click handler - Same as in User_BankAuction_detail
  const handleLocationClick = (e, item) => {
    e.stopPropagation();
    setLocationLoadingId(item.bankprop_id);
    
    const openInMaps = (url) => {
      setLocationLoadingId(null);
      window.open(url, '_blank', 'noopener,noreferrer');
    };

    // Check if we have latitude and longitude
    if (item.lat && item.long) {
      const locationString = `${item.lat},${item.long}`;
      const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locationString)}`;
      
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const userLat = position.coords.latitude;
            const userLng = position.coords.longitude;
            
            // Create directions URL from user's location to property
            const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${item.lat},${item.long}&travelmode=driving`;
            openInMaps(mapsUrl);
          },
          (error) => {
            console.error("Error getting location:", error);
            // Fallback to just showing the location
            openInMaps(fallbackUrl);
          },
          { timeout: 10000 }
        );
      } else {
        openInMaps(fallbackUrl);
      }
    } else {
      // If no lat/long, try to use location text
      const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.location || `${item.city_town}, ${item.area_town}`)}`;
      openInMaps(fallbackUrl);
    }
  };

const handleDeleteProperty = (e, property) => {
  e.stopPropagation();
  setPropertyToDelete(property);
  setShowDeleteConfirm(true);
};
const performDelete = async () => {
  if (!propertyToDelete) return;
  
  setDeletingId(propertyToDelete.bankprop_id);
  
  try {
    await axios.delete(`${BASE_URL}/auction-property/${propertyToDelete.bankprop_id}/`);
    
    // Remove the deleted property from state
    setData(prevData => prevData.filter(item => item.bankprop_id !== propertyToDelete.bankprop_id));
    
    setAlertMessage("Auction property deleted successfully!");
    setShowDeleteSuccess(true);
    
  } catch (err) {
    console.error("Error deleting property:", err);
    setAlertMessage("Failed to delete auction property. Please try again.");
    setShowDeleteFailure(true);
  } finally {
    setDeletingId(null);
    setPropertyToDelete(null);
  }
};



 useEffect(() => {
  const fetchData = async () => {
    try {
      const res = await axios.post(
        `${BASE_URL}/bank-properties/filter/`,
        {
          include: {
            user_id: Number(userId),
          },
          exclude: {},
        }
      );

      setData(res.data?.data || []);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setError("Failed to load bank auction properties");
      setLoading(false);
    }
  };

  if (userId) {
    fetchData();
  } else {
    setError("User not authenticated");
    setLoading(false);
  }
}, [userId]);

  // LOADING
  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          backgroundColor: colors.background,
        }}
      >
        <CircularProgress sx={{ color: "#000" }} />
        <Typography fontWeight={600}>
          Loading Auction Properties...
        </Typography>
      </Box>
    );
  }

  // ERROR
  if (error) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: colors.background,
        }}
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: colors.background,
      }}
    >
      {/* HEADER */}
      <AppBar position="fixed" sx={{ backgroundColor: colors.primary,zIndex: 1200, }}>
        <Toolbar>
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#fff" }}>
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography sx={{ ml: 2 }} fontWeight={600}>
            My Auction Properties
          </Typography>
        </Toolbar>
      </AppBar>

      {/* CONTENT */}
      <Box sx={{ p: 1.5, pb: 10 ,        pt: { xs: '80px', sm: '100px' },  
}}>
        {data.length === 0 ? (
          <Typography textAlign="center" sx={{ mt: 4 }}>
            No auction properties found
          </Typography>
        ) : (
          data.map((item) => {
            const imageUrls = getAllImageUrls(item.bank_pro_doc);
            const currentIndex = currentImageIndices[item.bankprop_id] || 0;
            const hasMultipleImages = imageUrls.length > 1;
            const isLocationLoading = locationLoadingId === item.bankprop_id;
            const isDeleting = deletingId === item.bankprop_id;
            
            return (
              <Card
                key={item.bankprop_id}
                onClick={() => handleCardClick(item)}
                sx={{
                  mb: 1.5,
                  borderRadius: 3,
                  p: 1.5,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  cursor: "pointer",
                  position: "relative",
                }}
              >
              <Box sx={{ display: "flex", gap: 1.5 }}>
  
  {/* ✅ LEFT SIDE (IMAGE + STATUS) */}
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    
    {/* IMAGE BOX */}
    <Box
      sx={{
        width: 90,
        height: 130,
        borderRadius: 2,
        backgroundColor: "#e6e0d4",
        position: "relative",
        overflow: "hidden",
        flexShrink: 0,
      }}
    >
      {imageUrls.length > 0 ? (
        <>
          <img
            src={imageUrls[currentIndex]}
            alt="Property"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            onError={(e) => {
              e.target.style.display = "none";
              const container = e.target.parentElement;
              if (container.querySelector(".no-image-text")) return;

              const noImageText = document.createElement("span");
              noImageText.className = "no-image-text";
              noImageText.textContent = "No Image";
              noImageText.style.cssText = `
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-weight: 700;
                font-size: 0.7rem;
                color: #555;
              `;
              container.appendChild(noImageText);
            }}
          />

          {/* Carousel Buttons */}
          {hasMultipleImages && (
            <>
              <IconButton
                onClick={(e) =>
                  prevImage(e, item.bankprop_id, imageUrls.length)
                }
                sx={{
                  position: "absolute",
                  left: 2,
                  top: "50%",
                  transform: "translateY(-50%)",
                  backgroundColor: "rgba(255,255,255,0.8)",
                  width: 20,
                  height: 20,
                  minWidth: 20,
                  padding: 0,
                }}
              >
                <ChevronLeftIcon sx={{ fontSize: 14 }} />
              </IconButton>

              <IconButton
                onClick={(e) =>
                  nextImage(e, item.bankprop_id, imageUrls.length)
                }
                sx={{
                  position: "absolute",
                  right: 2,
                  top: "50%",
                  transform: "translateY(-50%)",
                  backgroundColor: "rgba(255,255,255,0.8)",
                  width: 20,
                  height: 20,
                  minWidth: 20,
                  padding: 0,
                }}
              >
                <ChevronRightIcon sx={{ fontSize: 14 }} />
              </IconButton>

              {/* Dots */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: 4,
                  left: 0,
                  right: 0,
                  display: "flex",
                  justifyContent: "center",
                  gap: 0.5,
                }}
              >
                {imageUrls.map((_, index) => (
                  <Box
                    key={index}
                    onClick={(e) =>
                      handleDotClick(e, item.bankprop_id, index)
                    }
                    sx={{
                      width: 6,
                      height: 6,
                      borderRadius: "50%",
                      backgroundColor:
                        index === currentIndex ? "#1976d2" : "#ccc",
                      cursor: "pointer",
                    }}
                  />
                ))}
              </Box>
            </>
          )}
        </>
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "0.7rem",
              color: "#555",
            }}
          >
            No Image
          </Typography>
        </Box>
      )}
    </Box>

   {/* ✅ STATUS BELOW IMAGE */}
{item.admin_status && (
  <Typography
    sx={{
      mt: 0.5,
      fontSize: "0.65rem",
      fontWeight: "bold",
      textAlign: "center",
      px: 1,
      py: 0.3,
      border: `1px solid ${
        item.admin_status.toLowerCase() === "approved"
          ? "#4caf50" // Green
          : item.admin_status.toLowerCase() === "rejected"
          ? "#f44336" // Red
          : item.admin_status.toLowerCase() === "pending"
          ? "#ff9800" // Orange
          : "#9e9e9e" // Default Gray
      }`,
      color: "#000000be",
      backgroundColor: "#fff",
      width: "100%",
    }}
  >
    {item.admin_status}
  </Typography>
)}
  </Box>

  {/* ✅ RIGHT CONTENT */}
  {/* ✅ RIGHT CONTENT */}
<Box sx={{ flex: 1, minWidth: 0, pr: 1, display: "flex", flexDirection: "column" }}> 
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <Box
        sx={{
          backgroundColor: "#1a1a1a",
          color: "#fff",
          px: 1,
          borderRadius: 1.5,
          fontSize: "0.75rem",
          fontWeight: 600,
        }}
      >
        {formatCurrency(item.reserve_price)}
      </Box>
    </Box>

    <Typography fontSize="0.75rem" noWrap>
      <strong>Property:</strong> {item.property_type}
    </Typography>

    <Typography fontSize="0.75rem" noWrap>
      <strong>City/Town:</strong> {item.city_town}
    </Typography>

    <Typography fontSize="0.75rem" noWrap>
      <strong>Location:</strong> {item.location}
    </Typography>

    <Typography fontSize="0.75rem">
      <strong>Auction:</strong>{" "}
      {new Date(item.auction_start_datetime).toLocaleDateString()} -{" "}
      {new Date(item.auction_end_datetime).toLocaleDateString()}
    </Typography>

    <Typography fontSize="0.75rem" noWrap>
      <strong>Bank:</strong>{" "}
      {item.bank_name || "State Bank of India"}
    </Typography>

    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 1,
       mt: "auto",
      }}
    >
      {/* Location */}
      <Box
        onClick={(e) => handleLocationClick(e, item)}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.4,
          border: "1px solid #000",
          borderRadius: 1.5,
          px: 0.8,
          py: 0.3,
          cursor: "pointer",
        }}
      >
        <Typography sx={{ fontSize: "0.7rem" }}>
          Location
        </Typography>

        {isLocationLoading ? (
          <CircularProgress size={12} />
        ) : (
          <LocationOnIcon sx={{ fontSize: "0.9rem" }} />
        )}
      </Box>

      {/* Delete */}
      <IconButton
        onClick={(e) => handleDeleteProperty(e, item)}
        disabled={isDeleting}
      >
        {isDeleting ? (
          <CircularProgress size={20} />
        ) : (
          <DeleteIcon sx={{ color: "#ff4444" }} />
        )}
      </IconButton>
    </Box>
  </Box>
</Box>
              </Card>
            );
          })
        )}
      </Box>

  {/* Delete Success */}
      {showDeleteSuccess && (
        <DeleteSuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteSuccess(false);
            setAlertMessage("");
          }}
        />
      )}
      
      {/* Delete Failure */}
      {showDeleteFailure && (
        <DeleteFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteFailure(false);
            setAlertMessage("");
          }}
        />
      )}
{showDeleteConfirm && propertyToDelete && (
  <DeleteConfirmAlert
    message={`Are you sure you want to delete this auction property? This action cannot be undone.`}
    onOk={() => {
      setShowDeleteConfirm(false);
      performDelete();
    }}
    onCancel={() => {
      setShowDeleteConfirm(false);
      setPropertyToDelete(null);
    }}
  />
)}
      {/* BOTTOM NAV */}
      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
        <CustomBottomNavbar />
      </Box>


    </Box>
  );
};

export default User_BankAuction;